import React, {
  useState,
  useEffect,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Box, Button, Stack, Typography, useTheme, } from "@mui/material";

import { useAuth } from "./useAuth.jsx";
import RunScenario from "./RunScenario.jsx";
import RunSweep from "./RunSweep.jsx";
import { empty_uuid } from "./Account_urls.jsx";
import { TopBar } from "../Components/TopBar.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";
import IdeaBoardIcon from "../Dialogs/Idea/IdeaBoardIcon.jsx";
import UserGuideIcon from "../Components/UserGuideIcon.jsx";
import { isDev } from "../Components/Environment.jsx";
import { isSafari } from 'react-device-detect';


import NewsBoardIcon from "../Dialogs/Idea/NewsBoardIcon.jsx";
import { availabilityTag } from "../Pages/SignIn.jsx";
import YouTubeIcon from "../Components/YouTubeIcon.jsx";
import { ToolMenu } from "../Components/ToolMenu.jsx";

// normal top is 20
// 5 for any extra body lines notifications

const doSafariNotice = () => {
  return (false && isSafari)
}

export const TopOffset = 20 + (doSafariNotice() ? 10 : 0)


const TopNav = ({ clientJson, c_callback }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { admin_r, features_r, avatar_r, subscriber_, login_, logout_ } = useAuth();
  const [admin] = useState(admin_r.current)
  const [features] = useState(features_r.current)
  const [cj, setCj] = useState();
  function subscriberLogin(subscriber) {
    console.log("login: " + subscriber);
    login_(subscriber);
  }

  const getSubscriber = () => {
    return subscriber_;
  };
  const getSubscriberAvatar = () => {
    //console.log("avatar get: " + avatar_r.current);
    return avatar_r.current;
  };

  const LogOut = () => {
    console.log("Subscriber" + subscriber_ + "logged out");
    logout_();
    navigate("/signin");
  };


  useEffect(() => {
    console.log("TNav");
    console.log(clientJson);
    setCj(clientJson);
  }, [clientJson]);

  /*
   *
   */

  return (
    <>

      {doSafariNotice() && (
        <Box
          sx={{
            bgcolor: "#e2e200"
          }}
        >
          <Stack>
            <Typography variant="body2" gutterBottom={false}>
              Safari had issues with some MyOwnFP pages, we think we fixed them.
              If you have any issues please try Chrome, Firefox or Edge.
            </Typography>
            <Typography variant="body2" gutterBottom={false}>
              Any new issues will be logged automatically and fixed ASAP.
            </Typography>

          </Stack >
        </Box >
      )}
      <TopBar text={availabilityTag}>
        <Box sx={{ display: "flex", justifyContent: "flex-start", flexGrow: 1 }}>
          {/* {isDev() && (
            <Button
              onClick={() => { navigate("/subscriberSelect"); }}>
              Subscribers
            </Button>
          )} */}
          <Button
            onClick={() => { navigate("/clientSelect"); }}>
            Clients
          </Button>

          {clientJson.uuid !== empty_uuid && (
            <>
              <Button
                onClick={() => { navigate("/scenarioSelect"); }}>
                Scenarios
              </Button>
              <Button
                onClick={() => { navigate("/setupAccounts"); }}>
                Accounts
              </Button>
              <Button
                onClick={() => { navigate("/setupSavingRules"); }}>
                Saving/Income Rules
              </Button>

            </>
          )}

        </Box >
        <Stack direction="row" spacing={2}>
          <RunScenario clientJson={clientJson} c_callback={c_callback} />
          <RunSweep clientJson={clientJson} c_callback={c_callback} />
          <ToolMenu clientJson={clientJson} />
          <UserGuideIcon />
          <YouTubeIcon />
          <HelpIcon />
          <NewsBoardIcon />
          <IdeaBoardIcon />

          <Link to="/profile">
            <Avatar
              alt={getSubscriber()}
              src={getSubscriberAvatar()}
            ></Avatar>
          </Link>

          {/* <Button variant="contained" onClick={LogOut}>Logout</Button> */}
          <Button onClick={LogOut}>Logout</Button>
        </Stack>



      </TopBar>
    </>
  );
};

export default TopNav;
